// extracted by mini-css-extract-plugin
export default {"loginBtn":"button_loginBtn__MzM4F"};